{
    "roadmap": {
        "common": {
            "openAll": "Apri tutto",
            "closeAll": "Chiudi tutto",
            "openorCloseTitle": "Apri/Chiudi tutto l'accordione"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Cos'è NextGen IT: Porta l'automazione IT all'utente finale e risolvi il problema più velocemente.",
            "acc1Title": "In Produzione",
            "prodItem1": "Integrazione articolo KB: 300+ articoli KB che abilitano l'auto-risoluzione IT",
            "prodItem2": "Soluzione di auto-guarigione: Sono disponibili più di 18 script remoti per risolvere il problema.",
            "prodItem3": "Creazione di incidenti: Garantisce una risoluzione accurata e più veloce tramite la registrazione automatica degli incidenti.",
            "prodItem4": "Chat con agente dal vivo (agente umano): MyHelp consente agli utenti di chattare con un agente umano dall'assistente AI",
            "acc2Title": "In Sviluppo",
            "devItem1": "Programma richiamata (Feb - 2026): Programma una richiamata di supporto IT in un momento che si adatta alla tua disponibilità",
            "devItem2": "Instradamento intelligente (Feb - 2026): Instrada i ticket al team di risoluzione corretto per un supporto più rapido",
            "acc3Title": "In Backlog",
            "backItem1": "Agente di risoluzione dei problemi PKI: Integrazione MyHelp con l'agente di risoluzione dei problemi PKI per affrontare i problemi relativi ai certificati",
            "backItem2": "Programma appuntamenti al centro di accoglienza direttamente tramite MyHelp"
        },
        "corporate": {
            "title": "Corporate",
            "desc": "Il Corporate è responsabile della gestione delle applicazioni aziendali, delle piattaforme HR, che supportano le funzioni della forza lavoro e aziendali.",
            "acc1Title": "In Produzione",
            "prodItem1": "App basate su BU: 90+ app con personalizzazione basata su BU",
            "prodItem2": "Fissaggio app personalizzato: Gli utenti possono personalizzare il loro dashboard MyHelp fissando app personalizzate",
            "prodItem3": "Query sul luogo di lavoro: 100+ query sul luogo di lavoro (ufficio, parcheggio, edifici)",
            "prodItem4": "Prenotazione sala riunioni con assistente AI: Prenotazione sala riunioni rapida e semplificata con integrazione Gingco",
            "prodItem5": "Query HR: MyHelp risponde alle prime 50 query HR",
            "prodItem6": "Ricerca persone: Gli utenti possono cercare i loro colleghi E.ON tramite MyHelp",
            "acc2Title": "In Sviluppo",
            "devItem1": "Onboarding delle applicazioni basato sul rollout dell'unità aziendale.",
            "devItem2": "Assistente AI sala riunioni",
            "acc3Title": "In Backlog",
            "backItem1": "Aggiungi app dall'assistente AI e schede personalizzate: Aggiungi app istantaneamente tramite le opzioni suggerite dall'assistente MyHelp"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Questa integrazione ti aiuta a trovare corsi e formazione pertinenti.",
            "acc1Title": "In Produzione",
            "prodItem1": "Cerca corsi e formazione: Trova corsi e formazione pertinenti utilizzando MyHelp",
            "acc2Title": "In Sviluppo",
            "acc3Title": "In Backlog",
            "backItem1": "Apprendimento personalizzato: Raccomandazioni di formazione personalizzate basate sull'idoneità dell'unità aziendale."
        },
        "myItOrder": {
            "title": "MyIT order",
            "desc": "Questa integrazione ti aiuta a trovare articoli e cataloghi di ordini IT pertinenti.",
            "acc1Title": "In Produzione",
            "prodItem1": "Ricerca rapida nel catalogo ordini IT: Ricerca rapida e ordina il tuo IT da MyHelp",
            "prodItem2": "Abilitazione e revoca dell'accesso software: Abilita o revoca l'accesso al software navigando da MyHelp.",
            "acc2Title": "In Sviluppo",
            "devItem1": "Panoramica dei costi degli asset IT: MyHelp mostrerà una panoramica dei costi dei tuoi asset IT",
            "acc3Title": "In Backlog",
            "backItem1": "Approvazione centrale degli articoli ordinati"
        },
        "compass": {
            "title": "Compass",
            "desc": "Questa integrazione ti aiuterà a trovare comunità, informazioni e annunci condivisi sull'intranet.",
            "acc1Title": "In Produzione",
            "prodItem1": "Da rilasciare entro il 28 febbraio 2026",
            "acc2Title": "In Sviluppo",
            "devItem1": "Ricerca Compass (Feb – 2026): Gli utenti E.ON potranno cercare i dati della loro comunità nella ricerca E.ON MyHelp",
            "devItem2": "Assistente AI MyHelp-Compass (in corso) (Feb – 2026): Consentire agli utenti E.ON di accedere ai dati della comunità tramite l'assistente AI MyHelp",
            "acc3Title": "In Backlog"
        },
        "chatProjectData": {
            "title": "Chatta con i dati del tuo progetto",
            "desc": "Questa integrazione ti consente di integrare i dati del tuo progetto da confluence, sharepoint ecc.",
            "acc1Title": "In Produzione",
            "prodItem1": "I progetti One Billing e DSODP di Confluence sono integrati",
            "prodItem2": "Siti SharePoint – Il sito del progetto DSODP è integrato",
            "acc2Title": "In Sviluppo",
            "devItem1": "Lavoro sull'integrazione dei dati del progetto Nautilus è attualmente in corso.",
            "acc3Title": "In Backlog"
        },
        "personalization": {
            "title": "Personalizzazione",
            "acc1Title": "In Produzione",
            "prodItem1": "Multilingue: supporta 4 lingue (English, Deutsch, Svenska, Română)",
            "prodItem2": "Multi-tema: consente a ciascuna unità aziendale o regione di utilizzare il proprio branding, migliorando familiarità e adozione.",
            "prodItem3": "5 nuove lingue aggiuntive sotto profilo beta (Čeština, Italiano, Magyar, Nederlands e Polski)",
            "acc2Title": "In Sviluppo",
            "devItem1": "Fonte dati specifica: (15 febbraio – 2026): fornisce risposte più mirate e consapevoli del contesto estraendo informazioni dalle fonti dati selezionate dall'utente.",
            "acc3Title": "In Backlog"
        },
        "technicalEnablement": {
            "title": "Abilitazione Tecnica",
            "acc1Title": "In Produzione",
            "prodItem1": "Sicurezza e Osservabilità garantiscono protezione dei dati di livello aziendale, conformità e prestazioni, e consentono un funzionamento sicuro, affidabile e fluido delle operazioni",
            "prodItem2": "Dashboard KPI e adozione (Power BI)<br /> Fornisce una chiara visibilità sull'uso, la realizzazione del valore e l'impatto aziendale tramite dashboard KPI",
            "acc2Title": "In Sviluppo",
            "devItem1": "Flusso di lavoro multiagente entro il 15 marzo 2026: Consente conversazioni più guidate dall'intento che non solo migliorano la pertinenza delle risposte ma eseguono anche end-to-end per gli utenti.",
            "acc3Title": "In Backlog",
            "backItem1": "Framework MCP (Backlog): <br /> Fornisce una base per orchestrare e coordinare agenti AI in tutta E.ON, abilitando capacità AI aziendali scalabili e collaborative."
        }
    }
}